import { Component, OnInit } from '@angular/core';
import { AccessLink, AccessLinksService } from 'ldt-identity-service-api';
import { NotificationService } from '../../notification-service/notification.service';
import { AuthService } from 'src/app/auth/service/auth.service';
import { Router } from '@angular/router';
import { AccessLinkPostConfig } from 'src/app/admin/shared/access-link-post-editor/access-link-post-editor.component';

// interface PostAccessLink extends AccessLink {
//   post?: {
//     title: string;
//     description: string;
//     link: string;
//     imageUrl?: string;
//   };
// }

@Component({
    selector: 'app-post-browser',
    templateUrl: './post-browser.component.html',
    styleUrls: ['./post-browser.component.scss'],
    standalone: false
})
export class PostBrowserComponent implements OnInit {
  posts: AccessLink[] = [];
  filteredPosts: AccessLink[] = [];
  loading = false;
  searchQuery = '';
  selectedOrgId: string;

  constructor(
    private accessLinksService: AccessLinksService,
    private notify: NotificationService,
    private authService: AuthService,
    private router: Router
  ) {
    this.selectedOrgId = this.authService.getSelectedOrgIdValue;
  }

  ngOnInit(): void {
    this.loadPosts();
  }

  loadPosts(): void {
    this.loading = true;

    this.accessLinksService.listPosts().subscribe({
      next: (response) => {
        this.posts = (response.posts || []) as AccessLink[];

        this.filteredPosts = [...this.posts];
        this.loading = false;
      },
      error: () => {
        this.notify.error('Failed to load posts');
        this.loading = false;
      },
    });
  }

  onSearch(): void {
    if (!this.searchQuery.trim()) {
      this.filteredPosts = [...this.posts];
      return;
    }

    const query = this.searchQuery.toLowerCase();
    this.filteredPosts = this.posts.filter((post) => {
      const postConfig = post.post as AccessLinkPostConfig;
      const title = postConfig?.title?.toLowerCase() || '';
      const description = postConfig?.description?.toLowerCase() || '';

      return title.includes(query) || description.includes(query);
    });
  }

  openPost(post: AccessLink): void {
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/go/${post.token}`;
    window.open(url, '_blank');
  }

  openExternalLink(event: Event, post: AccessLink): void {
    event.stopPropagation();
    const postConfig = post.post as AccessLinkPostConfig;
    if (postConfig?.link) {
      window.open(postConfig.link, '_blank');
    }
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  handleImageError(event: any): void {
    // Hide broken images
    event.target.style.display = 'none';
  }
}
